<template>
  <div id="app">
    <div class="table">
      <search-bar ref="searchBarComponent">
        <div slot="search-tool"></div>
        <div slot="search-cont">
          <div class="item" >
            <div class="item-label">关键词搜索</div>
            <div style="width: 300px;">
              <el-input placeholder="请输入内容" v-model="info.key" class="input-with-select" size="small"  @keyup.enter.native='searchResume'>
                <el-select v-model="info.key_type" slot="prepend" placeholder="请选择" style="width: 130px" size="small">
                  <el-option label="姓名" value="1"></el-option>
                  <el-option label="电话号码" value="2"></el-option>
                </el-select>
                <el-button slot="append" icon="el-icon-search" @click='searchResume' size="small"></el-button>
              </el-input>
            </div>
          </div>
          <!--  操作按钮 start -->
          <div class="item">
            <el-button class="item-btn" type="primary" @click="getData">查询</el-button>
            <el-button class="item-btn reset-btn" @click="clearQuery">重置</el-button>
          </div>
          <!--  操作按钮 end -->


        </div>
      </search-bar>
      <div class="l-panel">
        <div class="panel-body">
          <div class="public-list" >
 
           <el-row>
              <el-col v-for="(item,index) in tableData" :key="index" class="p-item" :span="6">
                <div class="title">ID：{{item.id}}</div>
                <div class="content">
                  <div>姓名：{{item.fullname}}</div>
                  <div>电话：{{item.telephone}}</div>
                  <div>性别：{{item.sex_cn}}</div>
                  <div>年龄：{{item.birthdate}}</div>
                  <div>进入公共池时间：{{item.publictime}}</div>
                  <div>录入时间：{{item.addtime}}</div>
                  <div>最后操作时间：{{item.lastoperatetime}}</div>
                </div>
              </el-col>

            </el-row>
          </div>

        <div class="c-table-pager">
          <el-pagination :total="total" :page-size="page_size" @current-change='paginationChange'></el-pagination>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Message from '@/utils/message.js';
  export default {
    data() {
      return {
        page_size:8,
        info: {
          key_type: '',
          key: '',
          page: 1,
        },
        form: {
          page: 1
        },
        tableData: [],
        total: 1
      }
    },
    created() {
          this.$nextTick(() => {
            document.onselectstart = new Function("event.returnValue=false");
          });
    },
    mounted() {
      this.getData()
    },

    methods: {
      searchResume() {
        if(!this.info.key_type){
          return Message.warning('请选择类型')
        }
        this.info.page = 1
        this.getData()
      },

      paginationChange(val){
        this.info.page = val
        this.getData()
      },

      getData() {
        this.info.page_size = this.page_size;
        this.gets('oasystem/publiclist', this.info).then(res => {
          this.tableData = res.data.data.list
          this.total = res.data.data.total
        })
      },
      //重置
      clearQuery() {
        for(let key in this.info) {
          this.info[key] = '';
        }
        this.info.page = 1;
        this.getData()
      }
    }
  }
</script>

<style lang="scss" src="../../style/page/publicResources.scss"></style>



// WEBPACK FOOTER //
// src/view/oasystem/oapubliclist.vue